module.exports = __webpack_public_path__ + "img/appAsset-ui--integration.4b4e6956.svg";